class TokensAPI {

  static check = () => (_, unauthenticated) => unauthenticated.get('tokens/status')

  static get = credentials => (_, unauthenticated) => unauthenticated.post('tokens', credentials)

  static refresh = () => (_, unauthenticated) => unauthenticated.post('tokens/refresh')

  static requestReset = (email) => (_, unauthenticated) => unauthenticated.post('password/reset', {
    data: {
      type: 'passwordReset',
      attributes: {
        email: email
      }
    }
  })

  static resetPassword = ({token, password, passwordConfirmation}) => (_, unauthenticated) =>
    unauthenticated.put('password/reset', {
      data: {
        type: 'passwordReset',
        attributes: {
          token, password, passwordConfirmation
        }
      }
    })

  static setPassword = ({token, password, passwordConfirmation}) => (_, unauthenticated) =>
    unauthenticated.put('password/invitation', {
      data: {
        type: 'passwordInvitation',
        attributes: {
          token, password, passwordConfirmation
        }
      }
    })
}

export default TokensAPI
